// "Your login expired — sign in again" box (5.5.0, item f). Shown while
// authSession has a pending sign-in; renders nothing otherwise. The username is
// the user this window is signed in as (read-only), so one person's open work
// can't be saved under someone else's name. allowSignOut adds "Sign out
// instead…" (main app only), which warns about unsaved work and then does
// today's logout.
import React, { useEffect, useState } from 'react';
import { subscribe, onRenewed, signInAgain, cancelReauth, expectedUsername } from './authSession';

export default function ReloginBox({ allowSignOut = false, onSignedIn }) {
  const [st, setSt] = useState(null);
  const [password, setPassword] = useState('');
  const [typedUser, setTypedUser] = useState('');

  useEffect(() => subscribe((s) => { setSt(s); if (!s) setPassword(''); }), []);
  useEffect(() => (onSignedIn ? onRenewed(onSignedIn) : undefined), [onSignedIn]);

  if (!st) return null;
  const known = expectedUsername();

  const signOut = () => {
    if (!window.confirm('Sign out? Anything not yet saved in this window will be lost.')) return;
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  return (
    <div role="dialog" aria-label="Login expired" aria-modal="true"
      style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif' }}>
      <form onSubmit={(e) => { e.preventDefault(); signInAgain(password, typedUser); }}
        style={{ background: '#fff', color: '#111827', borderRadius: 10, padding: 20, width: 340,
          boxShadow: '0 8px 30px rgba(0,0,0,.3)' }}>
        <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 6 }}>Your login expired</div>
        <div style={{ fontSize: 13, color: '#374151', marginBottom: 12 }}>Sign in again to continue. Your changes are kept.</div>
        <input aria-label="Username" value={known || typedUser} readOnly={!!known}
          onChange={(e) => setTypedUser(e.target.value)} autoComplete="username"
          style={{ width: '100%', marginBottom: 8, padding: 6, boxSizing: 'border-box' }} />
        <input aria-label="Password" type="password" value={password} autoFocus
          onChange={(e) => setPassword(e.target.value)} autoComplete="current-password"
          style={{ width: '100%', marginBottom: 8, padding: 6, boxSizing: 'border-box' }} />
        {st.error && <div role="alert" style={{ color: '#dc2626', fontSize: 12, marginBottom: 8 }}>{st.error}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', alignItems: 'center' }}>
          {allowSignOut && (
            <button type="button" aria-label="Sign out instead" onClick={signOut}
              style={{ marginRight: 'auto', background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer' }}>
              Sign out instead…
            </button>
          )}
          <button type="button" aria-label="Cancel sign-in" onClick={cancelReauth}>Cancel</button>
          <button type="submit" aria-label="Sign in again" disabled={st.busy || !password}>
            {st.busy ? 'Signing in…' : 'Sign in'}
          </button>
        </div>
      </form>
    </div>
  );
}
